/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
export type TacticalOutputType = "ACTION" | "INFORMATION" | "PROJECT" | "REFERENCE_ITEM" | "TENSION";
import type { FragmentReference } from "relay-runtime";
declare export opaque type OutputForm_output$ref: FragmentReference;
declare export opaque type OutputForm_output$fragmentType: OutputForm_output$ref;
export type OutputForm_output = {|
  +databaseId: string,
  +type: TacticalOutputType,
  +title: ?string,
  +body: ?string,
  +description: string,
  +privateToCircle: boolean,
  +trigger: ?string,
  +projectStatus: ?string,
  +owner: ?{|
    +databaseId: string
  |},
  +person: ?{|
    +databaseId: string
  |},
  +$refType: OutputForm_output$ref,
|};
export type OutputForm_output$data = OutputForm_output;
export type OutputForm_output$key = {
  +$data?: OutputForm_output$data,
  +$fragmentRefs: OutputForm_output$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "databaseId",
  "storageKey": null
},
v1 = [
  (v0/*: any*/)
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "OutputForm_output",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "body",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "privateToCircle",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "trigger",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "projectStatus",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Role",
      "kind": "LinkedField",
      "name": "owner",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Person",
      "kind": "LinkedField",
      "name": "person",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": null
    }
  ],
  "type": "TacticalOutput",
  "abstractKey": null
};
})();
// prettier-ignore
(node/*: any*/).hash = 'f2bbf9b05ebeaea337558ac5ce7bf5c9';

module.exports = node;
